import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProjectsCategoriesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-projects-categories-edit',
	path: '/secure/admin/projectcategories/EditProjectCategory([!%]?[\\w]*).jspa',
};
